module.exports = "<sx-listado-desplegable [fuente]=\"grupos\" [tipo]=\"'PRODUCTREPORT' | translate\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/productReport/configurar.productreport.component.html
// module id = ../../../../../src/app/private/configuracion/productReport/configurar.productreport.component.html
// module chunks = main